// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__bgpw_"};